import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import CategoryPage from './pages/CategoryPage';
import AboutPage from './pages/AboutPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import NotificationPrompt from './components/NotificationPrompt';
// Known category slugs — everything else matching /:slug is treated as an article
const CATEGORY_SLUGS = new Set(['longevity', 'nutrition', 'research', 'mental-health', 'prevention']);

function SlugRouter() {
  const { slug } = useParams();
  if (CATEGORY_SLUGS.has(slug)) return <CategoryPage />;
  // Route all non-category slugs to ArticlePage (handles both clean and ID-suffixed slugs)
  return <ArticlePage />;
}

function App() {
  return (
    <Router>
      <NotificationPrompt />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/:slug" element={<SlugRouter />} />
      </Routes>
    </Router>
  );
}

export default App;
